import React from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import utils from '@/common/utils';

const { RangePicker } = DatePicker;

export default function ACoreRangePicker(props) {
  const { onChange = () => {}, format = ['YYYY-MM-DD HH:mm:ss'], value, ..._props } = props;

  function _onChange(value) {
    if (!value || !value[0] || !value[1]) return onChange([]);
    const first = value[0].toObject();
    const firstStr = `${first.years}-${utils.addZero(first.months + 1)}-${utils.addZero(first.date)} 00:00:00`;
    const sec = value[1].toObject();
    const secStr = `${sec.years}-${utils.addZero(sec.months + 1)}-${utils.addZero(sec.date)} 23:59:59`;
    onChange([moment(firstStr), moment(secStr)]);
  }

  return (
    <RangePicker
      {..._props}
      defaultPickerValue={[moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}
      value={value}
      format={format}
      onChange={_onChange}
    />
  );
}
